import { Button } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import GaDataStore from '../stores/GaDataStore';
import useStores from '../stores/UseStores';
import { runInTeliaRumService } from '../util/TeliaOtelUtil';

const LogoutButton = observer((): React.JSX.Element => {
  const {
    translateStore: { translate },
    logoutStore,
  } = useStores();

  const handleLogoutButtonClick = () => {
    GaDataStore.logout();
    runInTeliaRumService('Login välja', async () => {
      await logoutStore.logOut();
    });
  };

  return (
    <p className="text-left">
      <Button
        onClick={handleLogoutButtonClick}
        text={translate('mandates.logout')}
        iconLeft="#logout"
        link={true}
        type="text-color"
        isUnderlined={false}
        iconLeftSize="xxs"
      />
    </p>
  );
});

export default LogoutButton;
